import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import TrashV2 from 'assets/Icons/trashV2';
import IcEdit from 'assets/Icons/IcEdit';
import { QRCode } from 'antd';

export interface FileItemUploadProps {
  fileInfo?: string;
  onDelete?: () => void;
  borderRadius?: string;
  showQR?: boolean;
}

const FileItemUpload = ({ fileInfo, onDelete, borderRadius, showQR }: FileItemUploadProps) => {

  const onDeleteClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onDelete?.();
  };

  return (
    <Container $borderRadius={borderRadius}>
      { showQR ? (
        <QRCode value={fileInfo || ''} />
      ) : (
        <img src={fileInfo} className='avatar-image' />
      )}
      {!showQR && (
        <Overlay $borderRadius={borderRadius}>
          <Box display='flex' gap='3'>
            <Box className='action-box' style={{ background : '#2563EB'}}>
              <IcEdit fill='#FFF'/>
            </Box>
            <Box bgColor='v2_other_3' className='action-box' onClick={onDeleteClick}>
                <TrashV2 fill='#FFF'/>
            </Box>
        </Box>
        </Overlay>
      )}
    </Container>
  );
};

export default FileItemUpload;

const Container = styled.div<{ $borderRadius?: string }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  
  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${({ $borderRadius }) => $borderRadius || '100%'};
  }

   &:hover {
    & > div {
      display: flex;
    }
  }

`;

const Overlay = styled.div<{ $borderRadius?: string }>`
  position: absolute;
  background: rgba(0, 0, 0, 0.40);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 100px;
  min-height: 100px;
  border-radius: ${({ $borderRadius }) => $borderRadius || '100%'};
  display: none;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .action-box {
    width: 48px;
    height: 48px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
